import {defineStore} from 'pinia';
import {ModuleBudgetSource} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import ColumnCommon from '@/commons/wildcards/constants/ColumnCommon';
import budgetSourceAPI from '@/apis/di/budgetSourceAPI';

const budgetSource = new BaseDictionaryStore(budgetSourceAPI);

export const useBudgetSourceStore = defineStore(ModuleBudgetSource, {
  state: () => ({
    ...budgetSource.state,
    _config: {
      key: 'budget_source_id',
      code: 'budget_source_code',
      name: 'budget_source_name',
      table: 'di_budget_source',
      moduleName: 'Nguồn kinh phí',
      quickFollow: 'active',
      defaultSort: 'budget_source_code',
      isTree: true,
    },
    moduleName: 'budgetSource',
  }),
  actions: {
    ...budgetSource.action,
    /**
     *  cập nhật phát sinh nguồn kinh phí
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async updateBudgetSourceData(payload) {
      const res = await budgetSourceAPI.updateBudgetSourceData(payload || {});
      return res;
    },

    /**
     * Cập nhật dữ liệu khi chuyển danh mục (truyền vào list data)
     * ntban - 4.7.2023
     * @param {*} payload
     * @returns
     */
    async updateTranferListData(payload) {
      const me = this;
      const res = await budgetSourceAPI.updateTranferListData(payload || {});
      if (res) {
        if (payload.State == 0) {
          // context.commit('insertItem', payload.ToData);
          if (res) {
            me.items = [payload.ToData, ...me.items];
          }
        } else if (payload.State == 1) {
          this.updateItem(payload.ToData);
        }
      }
      return res;
    },
  },

  getters: {
    ...budgetSource.getters,

    // thêm getter không lấy props isParent
    sourceWithoutParent: state => {
      return state.items.map(i => {
        // return {...i, isParent: null};

        const newItem = {...i};
        delete newItem.isParent;

        return newItem;
      });
    },
  },
});
